import React from 'react'

import { Link } from 'react-router-dom'

import './sidebar.css'

import logo from '../../assets/images/logo.png'
import logoSmall from '../../assets/images/Logo_small.png'

import sidebar_items from '../../assets/JsonData/sidebar_routes.json'

const MOBILE_VISIBLE_ROUTES = new Set(['/', '/zakazky', '/zakazky/nova'])

const SidebarItem = props => {

    const active = props.active ? 'active' : ''

    return (
        <div className="sidebar__item">
            <div className={`sidebar__item-inner ${active}`}>
                <i className={props.icon}></i>
                <span>
                    {props.title}
                </span>
            </div>
        </div>
    )
}

const Sidebar = props => {

    const visibleItems = props.isMobile
        ? sidebar_items.filter((item) => MOBILE_VISIBLE_ROUTES.has(item.route))
        : sidebar_items.filter((item) => !item.adminOnly || props.canViewAllJobs)

    const isCollapsed = !props.isMobile && props.collapsed

    const activeItem = visibleItems.findIndex(item => {
        if (item.route === '/') return props.location.pathname === '/'
        return props.location.pathname === item.route || props.location.pathname.startsWith(`${item.route}/`)
    })

    const sidebarClassName = [
        'sidebar',
        isCollapsed ? 'sidebar--collapsed' : '',
        props.isMobile ? 'sidebar--mobile' : '',
        props.mobileOpen ? 'sidebar--mobile-open' : '',
    ].filter(Boolean).join(' ')

    const handleNavigate = () => {
        if (props.isMobile && props.onCloseMobile) {
            props.onCloseMobile()
        }
    }

    return (
        <div className={sidebarClassName}>
            <div className="sidebar__logo">
                <img src={isCollapsed ? logoSmall : logo} alt="Derator logo" />
            </div>
            <div className="sidebar__menu">
                {
                    visibleItems.map((item, index) => (
                        <Link to={item.route} key={index} onClick={handleNavigate}>
                            <SidebarItem
                                title={item.display_name}
                                icon={item.icon}
                                active={index === activeItem}
                            />
                        </Link>
                    ))
                }
            </div>
            {!props.isMobile ? (
                <div className="sidebar__footer">
                    <button
                        className="sidebar__collapse-btn"
                        type="button"
                        onClick={() => props.onToggleCollapse && props.onToggleCollapse()}
                        title={props.collapsed ? 'Rozbalit menu' : 'Sbalit menu'}
                        aria-label={props.collapsed ? 'Rozbalit menu' : 'Sbalit menu'}
                    >
                        <i className={`bx ${props.collapsed ? 'bx-chevrons-right' : 'bx-chevrons-left'}`}></i>
                        <span>{props.collapsed ? 'Rozbalit menu' : 'Sbalit menu'}</span>
                    </button>
                </div>
            ) : null}
        </div>
    )
}

export default Sidebar
